"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeybindRequestT = exports.KeybindRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const keybind_id_js_1 = require("../../solarxr-protocol/rpc/keybind-id.js");
class KeybindRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsKeybindRequest(bb, obj) {
        return (obj || new KeybindRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsKeybindRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new KeybindRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    keybindId() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : keybind_id_js_1.KeybindId.FULL_RESET;
    }
    static startKeybindRequest(builder) {
        builder.startObject(1);
    }
    static addKeybindId(builder, keybindId) {
        builder.addFieldInt8(0, keybindId, keybind_id_js_1.KeybindId.FULL_RESET);
    }
    static endKeybindRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createKeybindRequest(builder, keybindId) {
        KeybindRequest.startKeybindRequest(builder);
        KeybindRequest.addKeybindId(builder, keybindId);
        return KeybindRequest.endKeybindRequest(builder);
    }
    unpack() {
        return new KeybindRequestT(this.keybindId());
    }
    unpackTo(_o) {
        _o.keybindId = this.keybindId();
    }
}
exports.KeybindRequest = KeybindRequest;
class KeybindRequestT {
    constructor(keybindId = keybind_id_js_1.KeybindId.FULL_RESET) {
        this.keybindId = keybindId;
    }
    pack(builder) {
        return KeybindRequest.createKeybindRequest(builder, this.keybindId);
    }
}
exports.KeybindRequestT = KeybindRequestT;
